import React from 'react';
import PropTypes from 'prop-types';
import { StyledIcon } from './styled';

class Icon extends React.PureComponent {
  static defaultProps = {
    size: 'medium'
  };

  static propTypes = {
    size: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(
        ['small', 'medium', 'large', 'xlarge']
      ),
    ]),
  };

  _mapIconSize = (size) => {
    switch (size) {
      case 'xlarge':
        return 48;
      case 'large':
        return 32;
      case 'medium':
        return 24;
      case 'small':
        return 16;
      default:
        return size;
    }
  }

  render() {
    const {size, children} = this.props;
    const iconSize = this._mapIconSize(size);
    return (
      <i>
        <StyledIcon iconSize={size} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={`${iconSize}px`} height={`${iconSize}px`} viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
          {children}
        </StyledIcon>
      </i>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/elements/Icon/Icon.jsx